import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkIcon from '@material-ui/icons/Brightness2';
import {
  linuxellLightTheme,
  linuxellDarkTheme,
} from '../../themes/linuxell';

const linuxellLightThemeExtension = ThemeBlueprint.make({
  name: 'linuxell-light',
  params: {
    theme: {
      id: 'linuxell-light',
      title: 'Linuxell Light',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={linuxellLightTheme} children={children} />
      ),
    },
  },
});

const linuxellDarkThemeExtension = ThemeBlueprint.make({
  name: 'linuxell-dark',
  params: {
    theme: {
      id: 'linuxell-dark',
      title: 'Linuxell Dark',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={linuxellDarkTheme} children={children} />
      ),
    },
  },
});

export const themesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [linuxellLightThemeExtension, linuxellDarkThemeExtension],
});
